import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-create-new-conversation-button",
  templateUrl: "./create-new-conversation-button.component.html",
  styleUrls: ["./create-new-conversation-button.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CreateNewConversationButtonComponent {
  @Input() buttonText: string;
  @Input() disableIcon: boolean = false;
}
